module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/28f7d455e15b9e459aec9824ec85f346.png";